/**
 * DialogContent - MUI DialogContent Component Wrapper
 * 
 * A thin wrapper around Material-UI DialogContent component for consistent imports.
 */

import MuiDialogContent from "@mui/material/DialogContent";

const DialogContent = (props) => {
  return <MuiDialogContent {...props} />;
};

export default DialogContent;

